const sortByDate = (a, b) => {

	// If a has a value of null, we return 1 and therefore sort b before a.

	// If b has a value of null, we return -1 and sort a before b.

	// Otherwise, we use Math.sign() function returns either a positive or negative and sort it accordingly

	if (a.sortDate === null) {
		return 1;
	}

	if (b.sortDate === null) {
		return -1;
	}

	return Math.sign(a.sortDate - b.sortDate);
};

export default sortByDate;